import { PATHS } from '../../utils/paths';
import React from 'react';
import { Link } from 'react-router-dom';
import {CSS} from '../../utils/domUtils';
import {ReactComponent as HMenu} from '../../resources/img/hMenuOpen.svg';
import {ReactComponent as LogoGreen} from '../../resources/img/logoGreen.svg';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

type SideMenuProps = {
    setIsMenuOpen: (isOpen: boolean) => void;
  }

const SideMenu = ({setIsMenuOpen}: SideMenuProps) => {
  return (
    <>
      <div className={`${CSS.FLEX_ROW} ${CSS.HEADER}`}>
        <LogoGreen className={CSS.MENU_BUTTON}/>
        <HMenu className={CSS.MENU_BUTTON} onClick={() => setIsMenuOpen(false)}/>
      </div>
      <Link to={PATHS.CONTACT} className={CSS.CONTACT_LINK}>Contact us <ArrowOutwardIcon fontSize={'large'} className={CSS.ARROW_ICON}/></Link>
    </>
  )
}

export default SideMenu